import { Type } from '@angular/core';

import { ListReplicationRuleComponent } from './list-replication-rule.component';

export * from './list-replication-rule.component';

export const LIST_REPLICATION_RULE_DIRECTIVES: Type<any>[] = [
  ListReplicationRuleComponent
];
